import type { Message, MessageType, PayloadOf, TypedMessage } from '@navstation-portal/iframe/data-model/message-type';
import { generateId } from '@navstation-portal/shared/util/id';

const MESSAGE_TYPE_KEYS = {
  ready: true,
  config: true,
  ack: true,
  standard: true,
  settings: true,
  title: true,
} satisfies Record<MessageType, true>;

const MESSAGE_TYPES_SET = new Set(Object.keys(MESSAGE_TYPE_KEYS));

export function isMessageType(value: unknown): value is MessageType {
  return typeof value === 'string' && MESSAGE_TYPES_SET.has(value);
}

export function isMessage(value: unknown): value is Message {
  if (value == null || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }

  return isMessageType((value as Record<string, unknown>)['type']);
}

export function isMessageEvent(event: MessageEvent<unknown>): event is MessageEvent<Message> {
  return isMessage(event.data);
}

export function createMessage<T extends MessageType>(
  iframeId: string,
  type: T,
  payload: PayloadOf<T>
): TypedMessage<T> {
  return {
    id: generateId('msg'),
    iframeId,
    type,
    timestamp: Date.now(),
    payload,
  };
}
